module.exports = __webpack_public_path__ + "img/task-3-g.46ef8535.png";